import { Divider, EditableGrowingInput, ToolIcon, TooltipWrapper } from "@theorgchartdev/storybook";
import React, { Fragment, useRef } from "react";
import { useReportingContext } from "@/providers/ReportsProvider";
import { useRenameDocController } from "@/hooks/useRenameDocController";
import { QuickAccessMenu } from "@/appComponents/Navigation/Header/QuickAccessMenu/QuickAccessMenu";
import { useChartDocumentContext } from "@/providers/ChartDocumentProvider";
import cx from "classnames";
import { appstr } from "@coreapp/utils/appstr";

export const LeftHeaderReportControls = () => {
  const chartDocCtx = useChartDocumentContext();
  const handleRef = useRef(null);
  const doc = chartDocCtx.chartDocument.state;

  const { openReportExplorer, currentOpenReport, isOpenReportDirty } = useReportingContext();
  const { SaveSettings, nameInputRef } = useRenameDocController();

  const reportLabel = (() => {
    return currentOpenReport?.name ?? appstr("Untitled Report");
  })();

  const renameActive = handleRef?.current?.editMode;
  const showDirty = isOpenReportDirty;
  const renameClass = "oc-main-name-input";

  return (
    <Fragment>
      <Fragment>
        <ToolIcon
          dataTestId={"header-explorer-btn"}
          name={"compass"}
          size={"medium"}
          aria-label={"Refresh chart from source"}
          onClick={() => openReportExplorer()}
          shape={"round"}
        />
        <div className={"ocn-toolbar-horizontal-divider"}>
          <Divider vertical />
        </div>
      </Fragment>
      <TooltipWrapper tooltipProps={{ message: appstr("Rename") }}>
        <div className={cx(renameClass, !renameActive && showDirty && `${renameClass}--italic`)}>
          <EditableGrowingInput
            dataTestId={"oc-rename-input"}
            size={"large"}
            ref={nameInputRef}
            handleRef={handleRef}
            text={reportLabel}
            onChange={() => SaveSettings()}
          />
        </div>
      </TooltipWrapper>
      <div style={{ paddingLeft: "2px" }}>
        <QuickAccessMenu doc={doc} handleRef={handleRef} />
      </div>
    </Fragment>
  );
};
